exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".common-card-top[data-v-5e0fdecf]{padding:0.4rem;display:flex;justify-content:space-between}.common-card-top .title[data-v-5e0fdecf]{font-size:0.32rem;font-family:Roboto-Medium, Roboto;font-weight:500;color:#FFFFFF;line-height:0.4rem}.common-card-top .total[data-v-5e0fdecf]{margin-top:0.2rem;font-size:0.18rem;font-family:Roboto-Regular, Roboto;font-weight:400;color:#929DAD}\n", ""]);

// exports
